import PrematchOfferApiService from "@api-services/offer/PrematchOfferApiService";
import {
	PrematchMenuApiFilter,
	MenuResponse,
} from "@api-types/offer/PrematchMenuResponse";
import { TOfferRequest } from "@gp/hub";
import { PageableOfferResponse } from "@gp/models";
import { IOfferService } from "@services/offer/IOfferService";

class PrematchOfferService implements IOfferService {
	public async getOfferData(
		filter: TOfferRequest | null
	): Promise<PageableOfferResponse> {
		return await PrematchOfferApiService.getOfferData(filter);
	}
	public async getEventData(
		filter: TOfferRequest | null
	): Promise<PageableOfferResponse> {
		return await PrematchOfferApiService.getOfferData(filter);
	}
	public async getOfferMenu<K extends PrematchMenuApiFilter>(
		filter: K
	): Promise<MenuResponse<K>> {
		return await PrematchOfferApiService.getPrematchMenu(filter);
	}
}
export const prematchOfferService = new PrematchOfferService();
